import { render, staticRenderFns } from "./veBaseStudentXj.vue?vue&type=template&id=14c8a111&scoped=true"
import script from "./veBaseStudentXj.vue?vue&type=script&lang=js"
export * from "./veBaseStudentXj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8a111",
  null
  
)

export default component.exports